import { Action } from '@ngrx/store';

import { Update } from '@ngrx/entity';
import { IGradeRateEntity } from '../../interfaces/api/grade-rate-entity';

export enum GradeRateSignalTypes {
  LOAD_GRADE_RATES = '[GradeRate][Signal] Load Collection',
}
export enum GradeRateMessageTypes {
  SET_COLLECTION = '[GradeRate][Message] Set Collection',
  ADD_ONE = '[GradeRate][Message] Add One',
  UPDATE_ONE = '[GradeRate][Message] Update One',
  UPSERT_ONE = '[GradeRate][Message] Upsert One',
  DELETE_ONE = '[GradeRate][Message] Delete One',
  ADD_MULTIPLE = '[GradeRate][Message] Add All',
  DELETE_MULTIPLE = '[GradeRate][Message] Delete Many',
  UPSERT_MULTIPLE = '[GradeRate][Message] Upsert Many',
  UPDATE_MULTIPLE = '[GradeRate][Message] Update Many',
}
export class SetCollectionMessage implements Action {
  readonly type = GradeRateMessageTypes.SET_COLLECTION;
  constructor(public payload: { entities: IGradeRateEntity[] }) {}
}

export class AddOneMessage implements Action {
  readonly type = GradeRateMessageTypes.ADD_ONE;

  constructor(public payload: { entity: IGradeRateEntity }) {}
}

export class UpsertOneMessage implements Action {
  readonly type = GradeRateMessageTypes.UPSERT_ONE;

  constructor(public payload: { entity: IGradeRateEntity }) {}
}

export class AddMultipleMessage implements Action {
  readonly type = GradeRateMessageTypes.ADD_MULTIPLE;

  constructor(public payload: { entities: IGradeRateEntity[] }) {}
}

export class UpsertMultipleMessage implements Action {
  readonly type = GradeRateMessageTypes.UPSERT_MULTIPLE;

  constructor(public payload: { entities: IGradeRateEntity[] }) {}
}

export class UpdateOneMessage implements Action {
  readonly type = GradeRateMessageTypes.UPDATE_ONE;

  constructor(public payload: { entity: Update<IGradeRateEntity> }) {}
}

export class UpdateMultipleMessage implements Action {
  readonly type = GradeRateMessageTypes.UPDATE_MULTIPLE;

  constructor(public payload: { entities: Update<IGradeRateEntity>[] }) {}
}

export class DeleteOneMessage implements Action {
  readonly type = GradeRateMessageTypes.DELETE_ONE;

  constructor(public payload: { id: string }) {}
}

export class DeleteMultipleMessage implements Action {
  readonly type = GradeRateMessageTypes.DELETE_MULTIPLE;

  constructor(public payload: { ids: string[] }) {}
}

export type GradeRateMessages =
  | SetCollectionMessage
  | AddOneMessage
  | UpsertOneMessage
  | AddMultipleMessage
  | UpsertMultipleMessage
  | UpdateOneMessage
  | UpdateMultipleMessage
  | DeleteOneMessage
  | DeleteMultipleMessage;
